module.exports = __webpack_public_path__ + "img/ja-job-shadow.65fabd44.jpg";